<div class="container-fluid h-75">
  <div class="row row-padding-top-lg justify-content-between">
    <div class="col-3">
      <h2 class="title bold">Clients</h2>
    </div>
    <div class="col-3">
      <button class="btn btn-primary" (click)="addClient()">Add client</button>
    </div>
  </div>
  <div class="row grid-container">
    @if (initialized) {
      <app-clients-grid
        [gridName]="'VIVEClients'"
        [Filters]="Filters"
        [ColumnIdToColumnActions]="ColumnIdToColumnActions"
        (rowClick)="actionEvent({ action: 'view', rowData: $event.data })"
        (actionEvent)="actionEvent($event)"
      ></app-clients-grid>
    }
  </div>
</div>
